import { render, staticRenderFns } from "./SharedFiles.vue?vue&type=template&id=b00957be&"
import script from "./SharedFiles.vue?vue&type=script&lang=js&"
export * from "./SharedFiles.vue?vue&type=script&lang=js&"
import style0 from "./SharedFiles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b00957be')) {
      api.createRecord('b00957be', component.options)
    } else {
      api.reload('b00957be', component.options)
    }
    module.hot.accept("./SharedFiles.vue?vue&type=template&id=b00957be&", function () {
      api.rerender('b00957be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/SharedFiles.vue"
export default component.exports